<template>
    <div class="flex flex-row flex-wrap">
        <template v-for="(desc,index) in descriptions" v-if="showDescription(desc)">
            <description-view :field="field" :description="desc" />
        </template>
    </div>
</template>
<script>
import DescriptionView from "./DescriptionView";
import DescriptionScrollView from "./DescriptionScrollView";
//<div class="flex flex-row flex-wrap overflow-y-hidden overflow-x-auto">
export default {
    name: 'FiledOptionsDescriptions',
    components: { DescriptionScrollView, DescriptionView },
    props: {
        field: {},
    },
    computed: {
        descriptions() {
            return this.field.options.map(item => item.description).filter(item => this.showDescription(item));
        },
    },
    methods: {
        showDescription(desc) {
            return !!desc.text || !!desc.header
        }
    }
}
</script>